/* tslint:disable:import-spacing component-class-suffix no-inferrable-types variable-name
   typedef-whitespace component-selector no-trailing-whitespace */

import {
  AfterViewInit,
  Component,
  HostListener, Input
} from '@angular/core';

import * as $             from 'jquery';

import {InterLink}        from '@/models/scenario/inter.link';
import {TrainClass}       from '@/models/scenario/train.class';
import {Track, TrackType} from '@/models/scenario/track';
import {DecisionPoint}    from '@/models/scenario/decision.point';
import {Scenario}         from '@/models/scenario/scenario';
import {Logger}           from '@/util/logger';

import 'ag-grid-community';

import {StatusReporter} from "@/util/status.reporter";
import {
  GetContextMenuItemsParams,
  GridApi,
  GridReadyEvent
} from "ag-grid-community";

@Component({
  selector: 'time-table',
  template: `

    <div style="float: left; display: block; margin-top: 4px; margin-bottom: 4px;">
      <label style="float: left; display: block; margin-right: 12px; margin-top: 3px; margin-left: 16px;">Train Class:</label>
      <select style="float: left; display: block; width: 400px;" id="train-class-picker_{{uuid}}" class="train-class-picker form-control">
        <option value="0" data-id="0" selected="selected">Please Select</option>
      </select>
    </div>

    <div id="time-table-container_{{uuid}}" class="time-table-container" style="">
      <ag-grid-angular id="ag-grid-time-table_{{uuid}}" style="width: 100%; height: 100%;"
        class="ag-theme-balham-dark ag-grid-time-table"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [context]="context"
        [animateRows]="true"
        [enableRangeSelection]="true"

        [allowContextMenuWithControlKey]="true"
        [getContextMenuItems]="getContextMenuItems"

        (gridReady)="onGridReady($event)"
      >
      </ag-grid-angular>
    </div>
    `
})

/**
 *
 * @class TimeTable
 *
 * @brief @brief this table shows the speeds per milepost for a selected train class.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      November 2019
 *
 */
export class TimeTable implements AfterViewInit {

  @Input() uuid: number                 = 0;

  /** @var _scenario the scenario model */
  private _scenario: Scenario           = null;

  /** the API for the widget */
  private          api: GridApi         = null;

  private isFullScreen: boolean         = false;

  /** where we are sending our status messages */
  public statusReporter: StatusReporter = null;


  public context = {

    timeTable: this

  };

  public columnDefs: any[] = [

    {
      headerName: 'Decision Point',
      children: [
        {headerName: 'ROW',         field: 'row',      hide: true},
        {headerName: 'Mileage',     field: 'mileage',  editable: true, width: 150},
        {headerName: 'Name',        field: 'name',     editable: true, width: 150, columnGroupShow: 'open'},
        {headerName: 'MRT',         field: 'mrt',      editable: true, width: 60, columnGroupShow: 'open'}
      ]
    }

    /* on init no speed groups, we don't know how many there are yet */

  ];

  public defaultColDef = {
    sortable:  true,
    filter:    true,
    resizable: true
  };

  public rowData = [];

  /** update the error line in the loader drop down */
  public success(msg: string =  '') {

    if (this.statusReporter === null) {

      return ;
    }

    this.statusReporter.success(msg);
  }

  /** update the error line in the loader drop down */
  public error(msg: string =  '') {

    if (this.statusReporter === null) {

      return ;
    }

    this.statusReporter.error(msg);
  }

  onGridReady(params: GridReadyEvent): void {

    this.api       = params.api;
  }

  public toggleFullScreen(): void {


    if (this.isFullScreen) {

      Logger.debug('[time/table]', 'exiting full screen...');

      document.exitFullscreen();

    } else {

      Logger.debug('[time/table]', 'going full screen...');

      const elem = document.getElementById(`ag-grid-time-table_${this.uuid}`);

      if (elem.requestFullscreen) {

        elem.requestFullscreen();
      }
    }

  }

  public getContextMenuItems(params: GetContextMenuItemsParams): any {

    const     context: any[] = [];
    const gcTimeTable        = params.context.timeTable;

    if (context.length !== 0) {

      context.push('separator');
    }

    /* full screen control */

    let label: string = 'Show Full Screen';

    if (gcTimeTable.isFullScreen) {

      label = 'Exit Full Screen';
    }

    context.push( {
      name: label,
      action: () => {

        gcTimeTable.toggleFullScreen();
      }
    });

    context.push('separator');

    const general: any[] = [

      'copy',
      'copyWithHeaders',
      'paste',

      'separator',

      'expandAll',
      'contractAll',

      'separator',

      'csvExport',
      'excelExport',
      'excelXmlExport',

      'separator',

      'autoSizeAll'
    ];

    /* pass back the merged menu */

    context.push.apply(context, general);

    return context;
  }

  /** @brief first time setup of view */
  ngAfterViewInit() {

    Logger.debug('[time/table]', 'view init...');

    this.clear();

    const        elem = document.getElementById(`ag-grid-time-table_${this.uuid}`);
    const gcTimeTable = this;

    elem.addEventListener('fullscreenchange', () => {

      gcTimeTable.isFullScreen = document.fullscreenElement != null;

      Logger.debug('[time/table]', '(elem) flipped full screen mode: ', gcTimeTable.isFullScreen);

    }, true);
  }

  /** @brief reset the view to empty */
  public clear() {

    this._scenario = null;
  }

  /** @brief standard destructor */
  destroy() {

    Logger.debug('[time/table]', 'cleaning up...');

  }

  /** @brief set the table base on this scenario */
  setScenario(scenario: Scenario = null): boolean {

    if (scenario == null) {

      this.clear();

      return true;
    }

    /* save the model */

    this._scenario                   = scenario;

    let           tcId: number          = 0;
    const trainClasses: TrainClass[]    = this._scenario.trainClasses();

    if (trainClasses.length === 0) {

      /* nothing we can do, no train classes */

      Logger.error('[time/table]', 'scenario has no train classes!');

      return false;
    }

    /* set up the train class selector, we can't do anything until we can select train classes */

    let html: string = '';

    html += `
<select
  style="float: left; display: block; width: 400px;"
  id="train-class-picker_${this.uuid}"
  class="train-class-picker form-control">
`;

    {
      for (const tc of trainClasses) {

        /* if this is the placeholder for missing train class...then don't show it */

        let missing: TrainClass|null = this._scenario.getMissingTrainClass();

        if (missing._id == tc._id) {

          continue;
        }

        let attr: string   = '';
        attr = attr + ' data-name="' + tc._name + '" ';
        attr = attr + ' data-id="'   + tc._id + '" ';
        attr = attr + ' data-dir="'  + TrainClass.typeToString(tc._dir) + '" ';

        attr = attr + ' value="' + tc._id + '" ';

        html = html + '<option ' + attr + '>' + tc._name + '</option>\n';

      }
    }

    html = html + '</select>';

    $(`#train-class-picker_${this.uuid}`).replaceWith(html);

    const gcTimeTable = this;

    $(`#train-class-picker_${this.uuid}`).off('change');
    $(`#train-class-picker_${this.uuid}`).on('change',  () =>  {

      gcTimeTable.refreshTable();
    });

    /* check for a pre-selected train class in the URL */

    {
      const parms: any = new URLSearchParams(window.location.search);

      Logger.debug('[time/table]', 'URL params: ');

      for (const [k, v] of parms) {

        Logger.debug('[time/table]', '  ' + k + ' = ' + v);

        if ((k === 'trainclass') || (k === 'tcid')) {

          tcId = parseInt(v, 10);
        }
      }
    }

    /* default train class is just the first in the list */

    if (tcId === 0) {

      tcId = trainClasses[0]._id;

      /* force this to be the selected one */

      const selector = `#train-class-picker_${this.uuid} option[value='${tcId}']`;

      $(selector).prop('selected', true);
    }

    /* refresh the table based on currently selected train class */

    this.refreshTable();

    /* all done */

    return true;
  }

  public formatHours(time: number) {

    const            hours: number = Math.floor(time);
    const minutesRemainder: number = (time - hours) * 60;
    let            minutes: number = Math.floor(minutesRemainder);

    if (minutes > 59) {
      minutes = 59;
    }

    const secondsRemainder: number = (minutesRemainder - minutes) * 60;
    let            seconds: number = Math.round(secondsRemainder);

    if (seconds > 59) {
      seconds = 59;
    }

    return hours.toString().padStart(2, '0') +
      ':' +
      minutes.toString().padStart(2, '0') +
      ':' +
      seconds.toString().padStart(2, '0');
  }

  /** @brief helper to update the table w.r.t. a chosen train class */
  public refreshTable(): boolean {

    /* figure out the selected train class */

    const         tcId: number       = parseInt($(`#train-class-picker_${this.uuid} option:selected`).data('id'), 10);
    const trainClasses: TrainClass[] = this._scenario.trainClasses();
    let     trainClass: TrainClass   = null;

    for (const tc of trainClasses) {

      if (tc._id === tcId) {

        trainClass = tc;
        break;
      }
    }

    if (trainClass == null) {

      Logger.error('[time/table]', 'no such train class with id: ' + tcId);

      return false;
    }

    Logger.debug('[time/table] refreshing on train class: ' + trainClass._name +
      ' (' + trainClass._id + ') ' + TrainClass.typeToString(trainClass._dir));

    const dps: DecisionPoint[] = this._scenario.milePoints(true);

    /* map out what speeds going to have across all possible decision points */

    const   speeds: number[]         = [];
    const speedDef: Map<number, any> = new Map<number, any>();

    /* walk the decision points */

    let sidx: number = 1;

    for (const dp of dps) {

      /* walk the train classes */

      for (const [tid, speedMap] of dp._penalties) {

        if (tid !== trainClass._id) {

          /* not the train class we're focused on */

          continue;
        }

        /* walk the speeds at this decision point */

        for (const [speed, penalty] of speedMap) {

          if (speedDef.has(speed)) {

            /* we've already seen this one */

            continue;
          }

          speeds.push(speed);

          const suffix = '_' + sidx;
          const def = {

            suffix,
            speed,
            sidx,

            colDef: {

              headerName: speed + ' mph',
                children: [
                  {headerName: 'Hdwy',          field: 'headway'          + suffix, width: 150, editable: true},
                  {headerName: 'Hdwy fm Stp',   field: 'headwayStop'      + suffix, width: 150, editable: true, columnGroupShow: 'open'},
                  {headerName: 'Hdwy Slow',     field: 'headwaySlow'      + suffix, width: 150, editable: true, columnGroupShow: 'open'},
                  {headerName: 'Acc Stp',       field: 'stopAccel'        + suffix, width: 150, editable: true, columnGroupShow: 'open'},
                  {headerName: 'Acc Spd',       field: 'turnoutAccel'     + suffix, width: 150, editable: true, columnGroupShow: 'open'},
                  {headerName: 'Dcl Stp',       field: 'stopDecel'        + suffix, width: 150, editable: true, columnGroupShow: 'open'},
                  {headerName: 'Dcl Spd',       field: 'turnoutDecel'     + suffix, width: 150, editable: true, columnGroupShow: 'open'},
                  {headerName: 'Sw Clr Tm',     field: 'clearTime'        + suffix, width: 150, editable: true, columnGroupShow: 'open'},
                  {headerName: 'Sw Clr Tm Stp', field: 'clearTimeStopped' + suffix, width: 150, editable: true, columnGroupShow: 'open'},
                ]
            }

          };

          speedDef.set(speed, def);

          sidx = sidx + 1;

        } /* end of speed walk */

      } /* end of train class walk */

    } /* end of decision point walk */

    /* sort the speeds */

    speeds.sort((a, b): number => {

      if (a < b) {
        return -1;
      }

      if (a > b) {
        return 1;
      }

      return 0;
    });

    /*
     * now we can build the column defs since we have an ordering of the possible speeds, and the definition
     * of each one.
     *
     */

    this.columnDefs = [];
    this.rowData    = [];

    this.columnDefs.push(

      {
        headerName: 'Decision Point',
        children: [
          {headerName: 'ROW',         field: 'row',      hide: true},
          {headerName: 'Mileage',     field: 'mileage',  editable: true, width: 150},
          {headerName: 'Name',        field: 'name',     editable: true, width: 150, columnGroupShow: 'open'},
          {headerName: 'MRT',         field: 'mrt',      editable: true, width: 60,  columnGroupShow: 'open'}
        ]
      }

    );

    {
      for (const speed of speeds) {

        const def = speedDef.get(speed);

        this.columnDefs.push(def.colDef);
      }
    }

    this.api.setGridOption('columnDefs', this.columnDefs);

    /* now walk the decision points to build out the row data ... */

    let rowId: number = 1;

    for (const dp of dps) {

      /* basics for decision point ... */

      const rd = {
        row:     rowId,
        mileage: dp._mileage,
        name:    dp._name,
        mrt:     '00:00'
      };

      rowId++;

      /* for MRT, use the runtime for the first mainline we can find connected to this decision point */

      const bundle: InterLink = this._scenario.interLinkOfDecisionPoint(dp);

      if (bundle == null) {

        Logger.error('[time/table] can\'t find inter-link of dp: ' + dp._name + ' (' + dp._id + ')');

        continue;
      }

      /* figure out the main line track ... */

      let main: Track = null;
      let  mtn: number = 1000;

      for (const t of bundle._tracks) {

        if ((t._type === TrackType.MAIN) ||
            (t._type === TrackType.TERMINAL) ||
            (t._type === TrackType.PARKING)) {

          if (t._track < mtn) {

            main = t;
            mtn  = t._track;

          }
        }
      }

      if ((main == null) || (mtn > 1)) {

        Logger.error('[time/table] can\'t find eastbound mainline at dp: ' + dp._name + ' (' + dp._id + ')');

        continue;
      }

      /* now we have both a track and train class, so we can get the Minimum RunTime */

      if (main._mrt.has(trainClass._id)) {

        rd.mrt = this.formatHours(main._mrt.get(trainClass._id));
      }

      /* set the defaults for each speed group */

      {
        for (const speed of speeds) {

          const    def: any        = speedDef.get(speed);
          const suffix: string     = def.suffix;

          rd['headway'          + suffix] = '.';
          rd['headwayStop'      + suffix] = '.';
          rd['headwaySlow'      + suffix] = '.';
          rd['stopAccel'        + suffix] = '.';
          rd['turnoutAccel'     + suffix] = '.';
          rd['stopDecel'        + suffix] = '.';
          rd['turnoutDecel'     + suffix] = '.';
          rd['clearTime'        + suffix] = '.';
          rd['clearTimeStopped' + suffix] = '.';

        }
      }

      /* fill in the speeds we have at this decision point */

      for (const [tid, speedMap] of dp._penalties) {

        if (tid !== trainClass._id) {

          /* not the train class we're focused on */

          continue;
        }

        /* walk the speeds at this decision point */

        for (const [speed, penalty] of speedMap) {

          if (!speedDef.has(speed)) {

            /* unknown speed? */

            continue;
          }

          /* figure out the suffix (the unique key) for this column group */

          const    def: any    = speedDef.get(speed);
          const suffix: string = def.suffix;

          /* fill it in */

          rd['headway'          + suffix] = this.formatHours(penalty._headway);
          rd['headwayStop'      + suffix] = this.formatHours(penalty._headwayStop);
          rd['headwaySlow'      + suffix] = this.formatHours(penalty._headwaySlow);
          rd['stopAccel'        + suffix] = this.formatHours(penalty._stopAccel);
          rd['turnoutAccel'     + suffix] = this.formatHours(penalty._turnoutAccel);
          rd['stopDecel'        + suffix] = this.formatHours(penalty._stopDecel);
          rd['turnoutDecel'     + suffix] = this.formatHours(penalty._turnoutDecel);
          rd['clearTime'        + suffix] = this.formatHours(penalty._clearTime);
          rd['clearTimeStopped' + suffix] = this.formatHours(penalty._clearTimeStopped);
        }
      }

      this.rowData.push(rd);
    }

    this.api.setGridOption('rowData', this.rowData);

    /* this.gridColumnApi.autoSizeAllColumns(); */

    /* for now use horizontal scroll, table is getting really wide */
    /* this.gridApi.sizeColumnsToFit(); */

    /* all done */

    return true;
  }

  public focusOnPenalty(tcId: number) {

    Logger.debug('[time/table]', 'focusing on train class: ' + tcId);

    const selector = `#train-class-picker_${this.uuid} option[value='${tcId}']`;

    $(selector).prop('selected', true);

    this.refreshTable();
  }

  @HostListener('window:resize')
  public resize() {

    Logger.debug('[time/table]', 'resizing...');

    /* for now use horizontal scroll, table is getting really wide */
    /* this.gridApi.sizeColumnsToFit(); */
  }

}
